// extracted by mini-css-extract-plugin
module.exports = {"MemeData":"Form_MemeData__3E2_0","flexContainer":"Form_flexContainer__1h7Lt"};